<template>
  <v-app :dark="isDark" style="display: flex;">
    <layrz-sidebar
      :is-mobile="isMobile"
      :dark="true"
      :links="sidebarLinks"
      background-color="primary"
      :permanent="!isMobile"
      clipped
      :mini-variant="!isMobile"
      :state="drawer"
      :name="appName"
      :logo="appWhiteFavicon"
      :has-picture="hasAvatar"
      :avatar="avatar"
      :full-name="fullName"
      :actions="actions"
      :has-whitelabel="hasWhitelabel"
      :mobile-links="headerLinks"
      @set-state="(value) => $store.commit('setDrawer', value)"
    />
    <layrz-header
      :is-mobile="isMobile"
      :dark="isDark"
      :links="headerLinks"
      name=""
      :actions="actions"
      :logo="appLogo"
      :breakpoint="breakpoint"
      :avatar="avatar"
      :has-picture="hasAvatar"
      :full-name="fullName"
      :has-whitelabel="hasWhitelabel"
      clipped-left
      rounded-links
    />

    <v-main>
      <transition name="component-fade" mode="out-in">
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
// Golden M Packages
import {
  Sidebar as LayrzSidebar,
  Header as LayrzHeader
} from '@goldenm-software/generic-layout'

import { mapState, mapGetters } from 'vuex'
import whitelabel from '@/mixins/whitelabels'

export default {
  components: {
    LayrzSidebar,
    LayrzHeader
  },

  mixins: [whitelabel],

  data () {
    return {
      mqtt: null
    }
  },

  computed: {
    ...mapState(['isDark', 'whitelabel', 'session', 'drawer']),
    ...mapGetters({
      has: 'session/canSee',
      hasAvatar: 'session/hasAvatar',
      fullName: 'session/fullName',
      avatar: 'session/avatar',
      breakpoint: 'breakpoint',
      isMobile: 'isMobile'
    }),
    currentUser () {
      return this.session
    },
    mqttToken () {
      return this.session.mqttToken
    },

    actions () {
      const items = [
        {
          name: this.$i18n.t(`actions.darkMode.${this.isDark}`),
          action: () => this.$store.commit('toggleDark')
        }
      ]

      items.push({
        name: this.$i18n.t('pages.profile'),
        to: '/Profile'
      })
      items.push({
        name: this.$i18n.t('users.signOut'),
        action: () => this.$store.dispatch('session/logout')
      })
      return items
    },

    headerLinks () {
      return [
        {
          icon: 'mdi-home-city',
          to: '/Home',
          name: this.$i18n.t('pages.monitor.home'),
          can: true
        }
      ]
    },

    sidebarLinks () {
      if (this.currentUser.userType === 'Admin') {
        return [
          {
            icon: 'mdi-monitor',
            to: '/Home',
            name: this.$i18n.t('pages.monitor.home'),
            can: true
          },
          {
            icon: 'mdi-account',
            to: '/Users',
            name: this.$i18n.t('pages.admin.users'),
            can: true
          },
          {
            icon: 'mdi-cog',
            to: '/Configurations',
            name: this.$i18n.t('pages.admin.configuration'),
            can: true
          },
          {
            icon: 'mdi-car-connected',
            to: '/Units',
            name: this.$i18n.t('pages.admin.units'),
            can: true
          },
          {
            icon: 'mdi-account-cog',
            to: '/Accounts',
            name: this.$i18n.t('pages.admin.accounts'),
            can: true
          },
          {
            icon: 'mdi-card-account-details',
            to: '/Drivers',
            name: this.$i18n.t('pages.admin.drivers'),
            can: true
          },
          {
            icon: 'mdi-clipboard-account',
            to: '/Mechanics',
            name: this.$i18n.t('pages.admin.mechanics'),
            can: true
          },
          {
            icon: 'mdi-api',
            to: '/ApiTokens',
            name: this.$i18n.t('pages.admin.apiTokens'),
            can: true
          },
          {
            icon: 'mdi-account-group-outline',
            to: '/Groups',
            name: this.$i18n.t('pages.admin.groups'),
            can: true
          },
          {
            icon: 'mdi-map-marker-star',
            to: '/geofences',
            name: this.$i18n.t('pages.admin.geofences'),
            can: true
          },
          {
            icon: 'mdi-chart-timeline-variant',
            to: '/Reports',
            name: this.$i18n.t('pages.admin.reports'),
            can: true
          },
          {
            icon: 'mdi-chart-timeline-variant-shimmer',
            to: '/NewReports',
            name: this.$i18n.t('pages.admin.newReports'),
            can: true
          },
          {
            icon: 'mdi-bell-ring',
            to: '/Notifications',
            name: this.$i18n.t('pages.admin.notifications'),
            can: true
          },
          {
            icon: 'mdi-alert-box-outline',
            to: '/TPMSAlerts',
            name: 'TPMS Alerts',
            can: true
          }
        ]
      } else {
        return [
          {
            icon: 'mdi-monitor',
            to: '/Home',
            name: this.$i18n.t('pages.monitor.home'),
            can: true
          },
          {
            icon: 'mdi-account',
            to: '/Users',
            name: this.$i18n.t('pages.admin.users'),
            can: true
          },
          {
            icon: 'mdi-car-connected',
            to: '/Units',
            name: this.$i18n.t('pages.admin.units'),
            can: true
          },
          {
            icon: 'mdi-account-cog',
            to: '/Accounts',
            name: this.$i18n.t('pages.admin.accounts'),
            can: true
          },
          {
            icon: 'mdi-card-account-details',
            to: '/Drivers',
            name: this.$i18n.t('pages.admin.drivers'),
            can: true
          },
          {
            icon: 'mdi-clipboard-account',
            to: '/Mechanics',
            name: this.$i18n.t('pages.admin.mechanics'),
            can: true
          }
        ]
      }
    }
  },
  watch: {
    isDark (newVal) {
      this.$vuetify.theme.dark = newVal
    },

    mqttToken () {
      // if (newVal) {
      //   this.initMqtt()
      // }
    }
  },
  mounted () {
    // if (this.session.mqttToken && !this.mqtt) {
    //   this.initMqtt()
    // }
  }
}
</script>

<style lang="scss">
</style>
